import { render } from "./GibergDominic.vue?vue&type=template&id=16fbc83c&scoped=true"
import script from "./GibergDominic.vue?vue&type=script&lang=js"
export * from "./GibergDominic.vue?vue&type=script&lang=js"

import "./GibergDominic.vue?vue&type=style&index=0&id=16fbc83c&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16fbc83c"]])

export default __exports__